/*
 * File: Api.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: API endpoints for the scheduling routes
 */
import { Http } from "api/Http";
import { parseISO } from "date-fns";

const Api = new Http("scheduling/1");

class ApptsApi {
  constructor(api) {
    this.api = api;
  }

  fetch = async filters => {
    let res = await this.api.get("/appointments", filters);

    if (Array.isArray(res.data)) {
      return res.data.map(appt => {
        if (appt.startTime) {
          appt.startTime = parseISO(appt.startTime);
          appt.startDate = parseISO(appt.startTime);
        }
        return appt;
      });
    }
    return res.data || [];
  };

  fetchTransparencies = async filters => {
    if (!filters) return [];
    let res = await this.api.get("/transparencies", filters);

    return res.data || [];
  };

  find = async apptId => {
    let res = await this.api.get("/appointments/" + apptId);
    return res.data || {};
  };

  delete = async apptId => {
    await this.api.delete("/appointments/" + apptId);
  };

  create = async appt => {
    let res = await this.api.post("/appointments", appt);
    return res.data;
  };

  update = async appt => {
    let res = await this.api.patch("/appointments/" + appt.appointmentId, appt);
    return res.data;
  };

  confirm = async apptId => {
    await this.api.patch("/appointments/" + apptId + "/confirm", null);
  };

  fetchResources = async () => {
    let res = await this.api.get("/resources");
    return res.data || [];
  };

  fetchAppointmentTypes = async () => {
    let res = await this.api.get("/appointmentTypes");
    return res.data || [];
  };

  fetchAppointmentStatuses = async () => {
    let res = await this.api.get("/appointmentStatuses");
    return res.data || [];
  };

  fetchTreatmentPlans = async apptId => {
    let res = await this.api.get("/appointment/" + apptId + "/treatmentPlans");
    return res.data || [];
  };
}

const newApi = new ApptsApi(Api);
export default newApi;
